"use strict";

exports.__esModule = true;
exports.formFieldsetTheme = exports.formFieldDividerTheme = exports.formFieldTheme = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// [1] This deviates from h6 because it must look right when used both within
var formFieldTheme = function formFieldTheme(baseTheme) {
  return _objectSpread({
    FormFieldCaption_color: baseTheme.color_mouse,
    FormFieldCaption_fontSize: baseTheme.fontSize_mouse,
    FormFieldCaption_marginTop: baseTheme.space_stack_xxs,
    FormFieldCaption_marginTop_isGroup: baseTheme.space_stack_sm,
    FormFieldLabel_color: baseTheme.h6_color,
    FormFieldLabel_fontSize: baseTheme.h6_fontSize,
    FormFieldLabel_fontWeight: baseTheme.fontWeight_semiBold,
    // [1]
    FormFieldLabel_marginBottom: baseTheme.space_stack_sm,
    FormFieldSecondaryText_fontSize: baseTheme.fontSize_mouse,
    FormFieldSecondaryText_color: baseTheme.color_mouse,
    FormFieldSecondaryText_color_required: baseTheme.color_required,
    FormFieldSecondaryText_fontWeight: baseTheme.fontWeight_regular
  }, baseTheme);
};

exports.formFieldTheme = formFieldTheme;

var formFieldDividerTheme = function formFieldDividerTheme(baseTheme) {
  return _objectSpread({
    FormFieldDivider_borderColor: baseTheme.borderColor,
    FormFieldDivider_borderWidth: '1px',
    FormFieldDivider_margin: baseTheme.space_stack_sm
  }, baseTheme);
};

exports.formFieldDividerTheme = formFieldDividerTheme;

var formFieldsetTheme = function formFieldsetTheme(baseTheme) {
  return _objectSpread({
    FormFieldset_borderColor: baseTheme.borderColor,
    FormFieldsetLegend_color: baseTheme.h5_color,
    FormFieldsetLegend_fontSize: baseTheme.h5_fontSize,
    FormFieldsetLegend_fontWeight: baseTheme.h5_fontWeight
  }, baseTheme);
};

exports.formFieldsetTheme = formFieldsetTheme;